module.exports = __webpack_public_path__ + "static/media/Icon-awesome-instagram.0d4bc610.svg";